@if (totalPages > 1) {
<div class="pagination-wrapper">
  <div class="pagination-buttons">
    <ion-button
      fill="clear"
      class="nav-button"
      [disabled]="currentPage === 1"
      (click)="prev.emit()"
    >
      <ion-icon name="arrow-back-outline"></ion-icon>
      <span>{{ "pagination.previous" | translate }}</span>
    </ion-button>
    <ion-button
      fill="clear"
      class="nav-button"
      [disabled]="currentPage === totalPages"
      (click)="next.emit()"
    >
      <span>{{ "pagination.next" | translate }}</span>
      <ion-icon name="arrow-forward-outline"></ion-icon>
    </ion-button>
  </div>
  <p class="show-page-number">
    {{ "pagination.page" | translate }} {{ currentPage }} / {{ totalPages }}
  </p>
</div>
}
